<template>
  <div class="user-item">
    <loader class="user-item__loader" v-if="actionPending"></loader>
    <div class="user-item__info">
      <div class="user-item__name">
        {{ user.first_name }} {{ user.last_name }}
      </div>
      <div class="user-item__info-item">
        <div class="user-item__info-item-label">
          {{ $t('user-item.email.label') }}
        </div>
        <div class="user-item__info-item-value">
          {{ user.email }}
        </div>
      </div>
      <div class="user-item__info-item">
        <div class="user-item__info-item-label">
          {{ $t('user-item.phone.label') }}
        </div>
        <div class="user-item__info-item-value">
          {{ user.cell_phone }}
        </div>
      </div>
      <!--      <div class="user-item__last-visit">-->
      <!--        <div class="user-item__last-visit-title">-->
      <!--          {{ $t("user-item.last-visit.label") }}-->
      <!--        </div>-->
      <!--        <div class="user-item__last-visit-value">-->
      <!--          {{ user.last_visit_at }}-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="user-item__role">
      <user-role :role="user.role_slug"></user-role>
    </div>
    <div class="user-item__actions" v-click-outside="hideActionsList">
      <div class="user-item__actions-btn" @click="toggleActionsList">
        <svg
          width="20"
          height="4"
          viewBox="0 0 20 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="2" cy="2" r="2" fill="#B9C4D8" />
          <circle cx="18" cy="2" r="2" fill="#B9C4D8" />
          <circle cx="10" cy="2" r="2" fill="#B9C4D8" />
        </svg>
      </div>
      <div class="user-item__actions-list" v-if="isShowActionList">
        <require-access data="settings-users-edit" action="read">
          <div class="user-item__actions-list-item" @click="toEditUser">
            {{ $t('user-item.actions.edit') }}
          </div>
        </require-access>
        <require-access data="settings-users-reset_password" action="read">
          <div class="user-item__actions-list-item" @click="resetPassword">
            {{ $t('user-item.actions.reset-password') }}
          </div>
        </require-access>
        <require-access data="settings-users-delete" action="read">
          <div
            class="user-item__actions-list-item user-item__actions-list-item--delete"
            @click="deleteUser"
          >
            {{ $t('user-item.actions.delete') }}
          </div>
        </require-access>
      </div>
    </div>
    <user-delete-popup ref="userDeletePopup"></user-delete-popup>
    <user-reset-password-popup
      ref="userResetPasswordPopup"
    ></user-reset-password-popup>
    <success-notification
      ref="userPasswordResetNotification"
      :text="$t('user-item.notifications.password-reset-link-sent')"
    ></success-notification>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import UserRole from '@vue-app/components/user/parts/UserRole.vue'
import { mapState } from 'vuex'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import Loader from '@vue-app/components/base/Loader.vue'
import UserDeletePopup from '@vue-app/components/company/settings/users/popup/UserDeletePopup.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import UserResetPasswordPopup from '@vue-app/components/company/settings/users/popup/UserResetPasswordPopup.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

export default {
  name: 'UserItem',
  components: {
    RequireAccess,
    UserResetPasswordPopup,
    SuccessNotification,
    UserDeletePopup,
    UserRole,
    Loader,
  },
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      isShowActionList: false,
      actionPending: false,
    }
  },
  computed: {
    ...mapState(['selectedCompany']),
  },
  methods: {
    toggleActionsList() {
      this.isShowActionList = !this.isShowActionList
    },
    hideActionsList() {
      this.isShowActionList = false
    },
    toEditUser() {
      this.$router.push({
        name: 'edit-company-user',
        params: {
          id: this.selectedCompany,
          userId: this.user.user_id,
        },
      })
    },
    async resetPassword() {
      this.actionPending = true

      try {
        let isResetPassword = await this.$refs.userResetPasswordPopup.open()

        if (!isResetPassword) {
          return
        }

        await CompaniesApi.resetCompanyUserPassword(
          this.selectedCompany,
          this.user.user_id
        )
        await this.$refs.userPasswordResetNotification.show()
      } catch (e) {
      } finally {
        this.actionPending = false
      }
    },
    async deleteUser() {
      this.actionPending = true

      let isDeleteUser = await this.$refs.userDeletePopup.open()

      if (!isDeleteUser) {
        this.actionPending = false
        return
      }

      try {
        this.isShowActionList = false
        await CompaniesApi.deleteUserFromCompany(
          this.selectedCompany,
          this.user.user_id
        )
        $emit(this, 'userDeleted', this.user)
      } catch (e) {
      } finally {
        this.actionPending = false
      }
    },
  },
  emits: ['userDeleted'],
}
</script>

<style lang="scss" scoped>
.user-item {
  background: #ffffff;
  border-radius: 22px;
  padding: 25px 30px 27px 39px;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 0.5fr 30px;
  position: relative;
  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 22px;
  }

  &__name {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #465a8b;
    margin-bottom: 10px;
  }

  &__info {
    &-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      &-label {
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #465a8b;
        margin-right: 8px;
      }

      &-value {
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #585f6d;
      }
    }
  }

  &__last-visit {
    display: flex;
    align-items: center;

    &-title {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #b9c4d8;
      margin-right: 4px;
    }

    &-value {
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      color: #b9c4d8;
    }
  }

  &__actions {
    position: relative;

    &-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 10px 0 10px 10px;

      &:hover {
        opacity: 0.8;
      }
    }

    &-list {
      position: absolute;
      bottom: 30px;
      background: #ffffff;
      box-shadow: 0px 8px 20px rgba(225, 235, 253, 0.38);
      border-radius: 12px;
      border: 1px solid #f4f3fc;
      padding: 24px 32px;
      left: 50%;
      transform: translateX(-50%);

      &-item {
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        color: #64748B;
        margin-bottom: 18px;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        &--delete {
          color: #dd6262;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
